// import triangle from "../../../../../assets/documents/triangle.svg";

export const tableHeaderData = [
    {
        id:"unep-head-1",
        title:"дата выдачи",
        icon:"",
        width:"160px",
    },
    {
        id:"unep-head-2",
        title:"текущий статус",
        icon:"",
        width:"160px",
    },
    {
        id:"unep-head-3",
        title:"срок действия ЭЦП",
        icon:"",
        width:"220px",
    },
    {
        id:"unep-head-4",
        title:"ключ ЭЦП",
        width:"340px",
        icon:"",
    },
    {
        id:"unep-head-5",
        title:"номер телефона",
        icon:"",
        width:"180px",
    },
];
